import { api } from "@/lib/api";
import { getUTMs } from "@/lib/analytics";

export const PHONE_DISPLAY = "07429 565591";
export const PHONE_HREF = "tel:+447429565591";
export const WHATSAPP_HREF = "https://wa.me/447429565591";

export function sendEvent(event, { page, funnel, label } = {}) {
  const payload = { event, page: page || (typeof window !== "undefined" ? window.location.pathname : null), funnel: funnel || null, label: label || null };
  api.post("/events", payload).catch(() => {});
}

export function attribution() {
  const { first, current } = getUTMs();
  const u = { ...(first || {}), ...(current || {}) };
  let referral = null;
  try { referral = sessionStorage.getItem("kore_first_referrer") || document.referrer || null; } catch { /* ignore */ }
  return {
    utm_source: u.utm_source || null, utm_medium: u.utm_medium || null, utm_campaign: u.utm_campaign || null,
    utm_content: u.utm_content || null, utm_term: u.utm_term || null, referral,
  };
}

export function rememberReferrer() {
  try { if (!sessionStorage.getItem("kore_first_referrer") && document.referrer) sessionStorage.setItem("kore_first_referrer", document.referrer); } catch { /* ignore */ }
}
